/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */

import FlexBox from "src/components/Common/FlexBox"
import metamaskLogoImage from 'src/assets/metamask-logo.png'
import styled from "styled-components"
import { pxToVw } from "src/functions/units"
import { darken, transparentize } from "polished"

const WalletInstall = () => {
  return (
    <>
      <StyledHeader>Connect a wallet</StyledHeader>
      <StyledAnchor href="https://metamask.io/" target="_blank" rel="noreferrer">
        <FlexBox as='span' alignItems="center" justifyContent="space-between">
          <span>Install Metamask</span>
          <img src={metamaskLogoImage} alt="Metamask logo" />
        </FlexBox>
      </StyledAnchor>
    </>
  )
}

export default WalletInstall

const StyledHeader = styled.h3`
  margin-top: -${pxToVw(24)};
  font-size: ${pxToVw(28)};
  color: ${({ theme }) => theme.colors.gray700};
`

const StyledAnchor = styled.a`
  border-radius: ${pxToVw(22.5)};
  background-color: ${({ theme }) => theme.colors.gray200};
  border: solid 1px ${({ theme }) => theme.colors.gray};
  padding: ${pxToVw(24)} ${pxToVw(36)};
  display: block;

  &:hover {
    border-color: ${({ theme }) => theme.colors.primary};
    background-color: ${({ theme }) => transparentize(.9, theme.colors.primary)};

    > span {
      > span {
        color: ${({ theme }) => darken(.07, theme.colors.primary)};
      }

      > img {
        filter: grayscale(0);
      }
    }
  }

  > span {
    > span {
      font-size: ${pxToVw(24)};
      color: ${({ theme }) => darken(.15, theme.colors.gray700)};
    }

    > img {
      width: ${pxToVw(48)};
      height: ${pxToVw(48)};
      filter: grayscale(0.5);
    }
  }
`
